import {map} from 'lodash'

export const deviceStatus = {
  online: 'online',
  offline: 'offline',
  live: 'live',
  unknown: 'unknown'
}

export const browserStyles = {
  overlay: 'overlay',
  sideBySide: 'side-by-side',
  replace: 'replace'
}

export const view = {
  standard: 'standard',
  allEqual: 'all-equal',
}

export const browserToScreenRatio = {
  '1:1': '1:1',
  '2:1': '2:1',
  '1:2': '1:2'
}

export const getDefaultSignageOptions = isOfficeDevice => ({
  url: '',
  timerTill: 30,
  duration: 10,
  showByOddPairing: false,
  oddPairingUrl: '',
  showOnSleepMode: false,
  sleepModeUrl: '',
  signageStyle: browserStyles.sideBySide,
  signageToScreenRatio: browserToScreenRatio['1:1']
})

export const getDefaultBrowserConfig = (isOfficeDevice = false) => {
  return {
    specificUrl: false,
    url: '',
    buttonName: '',
    allowSearchBar: true,
    allowNewTabs: true,
    allowKeyboard: true,
    sessionExpiryLimit: true,
    sessionExpiryTime: 10,
    browserStyle: browserStyles.overlay,
    browserToScreenRatio: browserToScreenRatio['1:1'],
    cache: false,
    continueLeftOff: false
  }
}

export const getDefaultOptions = (isOfficeDevice = false) => {
  return {
    showJoinLeaveAudioButton: 1,
    speakerMode: 0,
    showMicrophoneButton: 1,
    microphoneMode: 0,
    showTimer: 1,
    timerLimit: 10,
    showGroupsButton: 1,
    showViewButton: 1,
    view: view.standard,
    showKnockButton: 1,
    showWhiteboardButton: 1,
    forceFullScreen: isOfficeDevice ? 1 : 0,
    // TODO this is remote device option only
    removeUiElements: 0,
    removePipVideoFeeds: 0,
    removeSelfView: 0,
    allowPinning: isOfficeDevice ? 1 : 0,
    allowRemoteAudioControl: isOfficeDevice ? 1 : 0,
    maximumResolution: isOfficeDevice ? '720p' : '320p',
    powerSavingMode: 0,
    syncJoinLeaveAudioWithGroup: 0,

    hideUserInterfaceElements: 0,
    hideSelfView: 0,
    hideButtons: 0,
    hideVideoTray: 0,
    hideOtherText: 0,
    hideLogos: 0,
    farSideImageLabel: '',
    imageLabelTransparency: 0,
    imageLabelPlacement: 'top',
    imageLabelSpacing: 6,
    imageLabelSize: 5,

    enableCensorship: 0,
    censorshipPeriod: 5,
    censorshipDebugMode: 0,
    censorshipRules: [],

    allowExternalCalling: isOfficeDevice ? 1 : 0,
    microsoftTeams: isOfficeDevice ? 1 : 0,
    zoom: isOfficeDevice ? 1 : 0,
    googleMeet: isOfficeDevice ? 1 : 0,
    webex: isOfficeDevice ? 1 : 0,

    videoResolutionOptions: 0,
    preferredCodec: 'av1',
    adaptiveMode: 1,
    svcSimulcast: 'svc',
    maxResolution: '720p',
    minResolution: '180p'
  }
}

export const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const officeDeviceDefaultHours = {from: 8, to: 20}
export const remoteDeviceDefaultHours = {from: 9, to: 17}

export const getDefaultOperationalHours = isOfficeDevice => {
  const defaultHours = isOfficeDevice ? officeDeviceDefaultHours : remoteDeviceDefaultHours
  return map(weekdays, (day, index) => ({
    day,
    is24Hours: false,
    hours: [defaultHours],
    active: index < 5
  }))
}

export const Hours = {
  0: '12 AM',
  1: '1 AM',
  2: '2 AM',
  3: '3 AM',
  4: '4 AM',
  5: '5 AM',
  6: '6 AM',
  7: '7 AM',
  8: '8 AM',
  9: '9 AM',
  10: '10 AM',
  11: '11 AM',
  12: '12 PM',
  13: '1 PM',
  14: '2 PM',
  15: '3 PM',
  16: '4 PM',
  17: '5 PM',
  18: '6 PM',
  19: '7 PM',
  20: '8 PM',
  21: '9 PM',
  22: '10 PM',
  23: '11 PM',
  24: '12 AM'
}

export const DEVICE_TYPE_OFFICE = 'device'
export const DEVICE_TYPE_REMOTE = 'remote'
